import React from 'react';
import { BuildingLogItem } from './BuildingLog';
import { formatDate } from '../../../common/utils/Date/Date';
import LogsGroup from './LogsGroup';

export interface NoChangeGroupProps {
  startDate: string;
  endDate: string;
  logs: BuildingLogItem[];
  isExpanded: boolean;
  toggleExpand: () => void;
}
export const NoChangeGroup: React.FC<NoChangeGroupProps> = ({ startDate, endDate, logs, isExpanded, toggleExpand }) => {
  const startDateObj = new Date(startDate);
  const endDateObj = new Date(endDate);
  const startDateStr = formatDate(startDateObj);
  const endDateStr = formatDate(endDateObj);

  const dateRangeText = startDateStr === endDateStr
    ? startDateStr
    : `${startDateStr} - ${endDateStr}`;

  return (
    <LogsGroup 
      title={dateRangeText}
      subtitle="Během tohoto období nebyla nalezena změna"
      subtitleWeight="400"
      subtitleColor="Neutral700"
      logs={logs}
      isExpanded={isExpanded}
      onToggle={toggleExpand}
      headerClassName="BuildingLogsGroup__header BuildingLogsGroup__header--noChange"
    />
  );
};

export default NoChangeGroup;
